export default __webpack_public_path__ + "static/media/books-1920w.3e56b12e.png";